import React, { useState } from 'react'
import { externalLoginStyles } from '../../helpers/loginStyles'
import { Field } from 'formik'
import { IMAGE_PATHS } from '../../constants'
import { toast } from 'react-toastify';
import externalLoginService from '../../services/externalLoginService'
import { isOtpLimitReached, startTimer } from '../../helpers/common';

const ResendPassword = ({ values, errors, touched, timerForOtp, setTimerForOtp, loginType }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleResendOtp = async () => {
        let resendOtpResetCount = parseInt(localStorage.getItem("resendOtpResetCount")) || 0;
        let resendOtpOldLoginCount = parseInt(localStorage.getItem("resendOtpOldLoginCount")) || 0;
        let resendOtpNewLoginCount = parseInt(localStorage.getItem("resendOtpNewLoginCount")) || 0;

        // Stop further resends if limit is reached for the current login type
        if (isOtpLimitReached(loginType)) {
            return toast.error("OTP resend limit reached. Please close the window.");
        } let purpose = "";
        if (loginType.login === "old_login") {
            purpose = "login";
        } else if (loginType.login === "new_login") {
            purpose = "set-password";
        } else {
            purpose = "reset-password"
        }

        let resendPayload = {
            emailId: values.userName,
            purpose
        };
        setIsLoading(true);
        const resendOtpResponse = await externalLoginService.resendOtp(resendPayload);
        setIsLoading(false);
        if (resendOtpResponse?.data?.isSuccess) {
            if (loginType.login === "old_login") {
                localStorage.setItem("resendOtpOldLoginCount", ++resendOtpOldLoginCount);
            } else if (loginType.login === "new_login") {
                localStorage.setItem("resendOtpNewLoginCount", ++resendOtpNewLoginCount);
            } else {
                localStorage.setItem("resendOtpResetCount", ++resendOtpResetCount);
            }
            startTimer(setTimerForOtp);
            toast.success(resendOtpResponse?.data?.message);
        } else {
            toast.error(resendOtpResponse?.response?.data?.message);
        }
    };

    return (
        <div>
            <label htmlFor="otp" className="form-label">
                OTP *
            </label>
            <div style={externalLoginStyles.step2_container}>
                <Field
                    type="text"
                    name="otp"
                    placeholder="Enter Otp Here"
                    autoComplete="off"
                    className={`form-control otp-field-width ${touched.otp && errors.otp ? 'is-invalid' : ''}`}
                    style={{ WebkitTextSecurity: "disc" }}
                />
                <div className="otpbox_bottom">
                    {!timerForOtp ? null : <>
                        <img
                            src={IMAGE_PATHS.time_icon}
                            loading="lazy"
                            alt="time icon"
                            className='ms-2'
                        />{" "}
                        {timerForOtp} s
                    </>}

                    <span style={{
                        color: timerForOtp || isLoading ? "#D3D3D3" : "#0a3152", cursor: timerForOtp || isLoading ? "default" : "pointer",
                    }}
                        className='ms-2'
                        onClick={() => {
                            if (!timerForOtp) {
                                if (!isLoading) {
                                    handleResendOtp(values)
                                }
                            }
                        }}
                        disabled={isOtpLimitReached(loginType)}
                    >
                        Resend OTP
                    </span>
                </div>
            </div>
            {errors.otp && touched.otp ? (
                <p className="errorMsg">{errors.otp}</p>) : null}

        </div>
    )
}

export default ResendPassword